/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteAutomaticPausesConfiguration$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
  configurationType: 'COUNTING_ORDERS' | 'WEIGHTED_ITEMS';
}

export function deleteAutomaticPausesConfiguration(http: HttpClient, rootUrl: string, params: DeleteAutomaticPausesConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteAutomaticPausesConfiguration.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.path('configurationType', params.configurationType, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteAutomaticPausesConfiguration.PATH = '/stores/{storeId}/automatic-pauses/{configurationType}';
